module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-center animated fadeInRight"
  }, [(_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Подождите..."
    }
  }) : _c('form', {
    staticClass: "col-lg-6 col-md-8 col-sm-12",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.remindEmail()
      }
    }
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h1', [_vm._v("Забыли пароль?")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted mt-2 mb-2"
  }, [_vm._v("\n                        Сбросить пароль используя электронну почту\n                        ")]), _vm._v(" "), (_vm.type === 'email') ? _c('div', {
    staticClass: "mb-1"
  }, [_c('div', {
    staticClass: "input-group",
    class: {
      'has-danger': _vm.error || _vm.$v.remind.email.$error
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remind.email),
      expression: "remind.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "type": "email",
      "placeholder": "Электронная почта"
    },
    domProps: {
      "value": (_vm.remind.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.remind, "email", $event.target.value)
      }, function($event) {
        _vm.$v.remind.email.$touch()
      }]
    }
  })]), _vm._v(" "), (_vm.$v.remind.email.$error) ? _c('small', {
    staticClass: "help-block text-danger"
  }, [_vm._v("Адрес электронной почты должен быть валидным")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('small', {
    staticClass: "help-block text-danger"
  }, [_vm._v("Данный адрес электронной почты не найден")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.type === 'phone') ? _c('div', {
    staticClass: "mb-1"
  }, [_c('div', {
    staticClass: "input-group",
    class: {
      'has-danger': _vm.error
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("+7")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remind.phone),
      expression: "remind.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "Номер телефона"
    },
    domProps: {
      "value": (_vm.remind.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.remind, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('small', {
    staticClass: "help-block text-danger"
  }, [_vm._v("Данный номер телефона не найден")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-5 mb-2"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4",
    class: {
      'disabled': _vm.$v.remind.$invalid
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Сбросить пароль")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-7 mb-2 text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-secondary",
    attrs: {
      "to": {
        name: 'Auth'
      }
    }
  }, [_vm._v("Вернуться к странице авторизации")])], 1)])])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-59d08568", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-59d08568"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Auth/RemindPassword.vue
// module id = 1041
// module chunks = 1